module.exports = __webpack_public_path__ + "img/nl.cc67d5db.svg";